module.exports = __webpack_public_path__ + "img/slide1-992.6fbdf3ca.png";